var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-ag-grid',{attrs:{"title":"Tickets","columnDefs":_vm.columnDefs,"rowData":_vm.tickets,"loading":_vm.loading,"mobileCard":_vm.mobileCard,"newBtn":false},on:{"refresh":_vm.fetchTickets,"row-dbl-click":(data) => _vm.$router.push({ path: `tickets/${data._id}/edit` })}})
}
var staticRenderFns = []

export { render, staticRenderFns }